import { render, staticRenderFns } from "./DressListingProduct.vue?vue&type=template&id=5abe57a3&scoped=true"
import script from "./DressListingProduct.vue?vue&type=script&lang=js"
export * from "./DressListingProduct.vue?vue&type=script&lang=js"
import style0 from "./DressListingProduct.vue?vue&type=style&index=0&id=5abe57a3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5abe57a3",
  null
  
)

export default component.exports